import React, { FunctionComponent } from "react";
import ContentItem from "components/content/ContentItem";
import { Link } from "../../config/components";
import { Button } from "@material-ui/core";

type CallToActionButtonProps = {
  code: string;
};

export const CallToActionButton: FunctionComponent<CallToActionButtonProps> = ({
  code,
}) => {
  return (
    <ContentItem code={code}>
      {(item) => {
        return (
          item &&
          (item as Link).url && (
            <Button
              className="link"
              variant="outlined"
              size="medium"
              href={(item as Link).url.toString()}
            >
              {(item as Link).label}
            </Button>
          )
        );
      }}
    </ContentItem>
  );
};

export default CallToActionButton;
